import { create } from "zustand";
import { closeOtherModals, registerModalStore } from "./modal-registry";

/** Key this store is known by in the modal registry. */
const MODAL_NAME = "add-to-color-collection";

export const useAddToColorCollectionModalStore = create((set) => ({
  isModalOpen: false,
  addToCollectionUrl: null,
  openModal: (url) => {
    closeOtherModals(MODAL_NAME);

    set({ isModalOpen: true, addToCollectionUrl: url });
  },
  closeModal: () => set({ isModalOpen: false, addToCollectionUrl: null }),
  updateIsModalOpen: (isModalOpen) => set({ isModalOpen }),
}));

registerModalStore(MODAL_NAME, useAddToColorCollectionModalStore);
